import React, {PropTypes} from 'react';
import { LocaleProvider, Modal, Button } from 'antd';
import { connect } from 'react-redux';
// import { GiftIcon } from '../core/icons'
import "./CouponUpsellModal.css"

import {
  Link
} from 'react-router-dom'

const queryString = require('query-string')

const GiftIcon = () =>
<img src="data:image/svg+xml;base64,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"/>

class CouponUpsellModal extends React.Component {
  state = { visible: false }

  componentDidMount = () => {
    // ignore on plan=monthly or plan=yearly
    const parsed = queryString.parse(window.location.search)
    if (parsed.plan=='monthly' || parsed.plan=='yearly') return

    if (localStorage.getItem('couponUpsellModalDismissed')===null) {
      this.setState({
        visible: true,
      });
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }
  handleOk = (e) => {
    localStorage.setItem('couponUpsellModalDismissed', true)

    this.setState({
      visible: false,
    });
  }
  handleCancel = (e) => {
    localStorage.setItem('couponUpsellModalDismissed', true)

    this.setState({
      visible: false,
    });
  }
  render() {
    if (!this.props.models.user.isAuthenticated) return null
    if (!this.props.models.user.isFetching && !this.props.models.user.hasSubscription && this.state.visible) return (

        <Modal
          // title="Basic Modal"
          visible={true}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
          className="CouponUpsellModal"
        >
          <div style={{display:'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>

            <GiftIcon/>
            <h3>Get 18% Off Premium</h3>
            <p>
              With code:
              <br/>
              <code>2018</code>
              <br/>
              Valid only today!
            </p>

            <div style={{display:'flex', justifyContent: 'center', alignItems: 'center'}}>

              <Link onClick={this.handleOk} to={'/premium?plan=yearly&coupon=2018'}><Button type='primary'>Upgrade Now</Button></Link>
            </div>
          </div>
        </Modal>
    
    );
    return null
  }
}

export default connect(state=>state)(CouponUpsellModal)



// WEBPACK FOOTER //
// ./src/modal/CouponUpsellModal.js